<template>
  <div class="Productdetail">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Products Detail</h2>
        </div>
      </div>

      <div class="container productDetailsPage">
        <div class="product-right panel">
          <div class="row">
            <div class="col-md-5 col-sm-12">
              <div class="slide_bx">
                <img v-lazy="imageBaseUrl+details.image" />
              </div>
            </div>
            <div class="col-md-7 col-sm-12">
              <h2>{{details.productName}}</h2>
              <div
                class="price"
              >{{currency}}{{details.price_per_unit.toFixed(2)}}/ {{details.product_unit}}</div>
              <!-- <p>Schedule - noon</p> -->
              <div class="line"></div>

              <div class="subscribe_bx" id="subs_bx">
                <div class="border listbox">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="selectDatePicker">
                        <h4>Select Start Date</h4>
                        <p>{{ showDateModal }}</p>
                        <datepicker
                          ref="programaticOpen"
                          disabled
                          v-model="showDateModal"
                          :format="customFormatter"
                          @selected="setDate"
                        ></datepicker>
                        <button class="calendarBtn" @click="openPicker">
                          <i class="fa fa-calendar"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border listbox" @click="$bvModal.show('deiverySchedule')">
                  <div class="row">
                    <div class="col-md-12">
                      <h4>Select Delivery Schedule</h4>
                      {{selectedSchedule}}
                      <span class="clockIcon">
                        <img src="../assets/images/fast.svg" />
                      </span>
                    </div>
                  </div>
                </div>
                <div class="quantity">
                  <div class="border listbox">
                    <div class="row">
                      <div class="col-md-12" @click="$bvModal.show('addDeliveryAddress')">
                        <p class="addressSelectBtn">
                          Select Deliveries
                          {{selectedDays}}
                          <img
                            class="nextIconImg"
                            src="../assets/images/next.svg"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="total_amt">
                Total Amount
                <span>{{currency}}{{details.subscriptionTotalPrice}}</span>
              </div>
              <div class="btn_rw">
                <a
                  id="pause"
                  class="btn btn-primary activebtn"
                  @click="$bvModal.show('confirmActivation')"
                >Confirm</a>
                <a
                  id="cancel"
                  class="btn btn-primary cancel"
                  href="#"
                  data-toggle="modal"
                  data-target="#"
                >Previous</a>
              </div>
            </div>
            <b-modal id="deiverySchedule">
              <template v-slot:modal-title>Select Delivery Schedule</template>

              <div class="deliveryAddressList">
                <ul>
                  <div class="radiobtn">
                    <b-form-radio-group
                      id="btn-radios-2"
                      v-model="selectedSchedule"
                      :options="deliverySchedules"
                      name="radio-btn-outline"
                    ></b-form-radio-group>
                  </div>
                </ul>
              </div>
              <template v-slot:modal-footer>
                <b-button @click="$bvModal.hide('deiverySchedule')">Ok</b-button>
              </template>
            </b-modal>
            <b-modal id="confirmActivation" hide-header>
              Do you want to Activate the subscription?
              <template v-slot:modal-footer>
                <b-button @click="gotoPayments()">Yes</b-button>
                <b-button @click="$bvModal.hide('confirmActivation')">No</b-button>
              </template>
            </b-modal>
            <b-modal id="addDeliveryAddress" hide-footer>
              <template v-slot:modal-title>I Want</template>

              <div class="deliveryAddressList">
                <ul>
                  <div class="radiobtn">
                    <b-form-radio-group
                      id="btn-radios-1"
                      v-model="selectedDays"
                      :options="getDays"
                      v-on:change="onSelectDeliveries($event)"
                      name="radio-btn-outline"
                    ></b-form-radio-group>
                  </div>
                </ul>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import "../../node_modules/vue-slick-carousel/dist/vue-slick-carousel.css";
import "../../node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueSlickCarousel from "vue-slick-carousel";
import { getDeliveryDuration, getDeliveries } from "./../services/api";
import moment from "moment";
import VueLazyload from "vue-lazyload";
import Vue from "vue";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "giphy.gif",
  attempt: 1
});
export default {
  name: "product",
  components: {
    Datepicker
  },
  data() {
    return {
      currency: localStorage.getItem("CurrencySymbol"),
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      format: "dd MMMM yyyy",
      disabledDates: {},
      showDateModal: null,
      quantity: 0,
      daysDetails: [],
      getDays: [],
      selectedDays: "",
      details: "",
      deliverySchedules: [],
      selectedSchedule: ""
    };
  },
  created() {
    this.getDuration();
    this.details = JSON.parse(localStorage.getItem("productSubscribed"));
    console.log("*", this.details);
    this.setValues();
  },
  methods: {
    displayDeliveries() {},
    displaySchedules() {
      var au = this.deliverySchedules.filter(
        item => item.id == this.selectedSchedule
      );
    },
    setValues() {
      var a = this.details.startdate.split("T");
      var b =
        moment(a[0], "DD-MM-YYYY", true).format("YYYY-MM-DD") +
        "T" +
        a[1] +
        "+00:00";
      this.showDateModal = moment(b).format("DD MMMM, YYYY");
      this.getDeliverySchedule(moment(this.showDateModal).format("YYYY-MM-DD"));
      this.selectedDays = this.details.deliverySchduleTimig[0].ds_id;
      this.selectedSchedule = this.details.duration_id;
      this.displaySchedules();
    },
    customFormatter(date) {
      return moment(date).format("MMMM DD YYYY");
    },
    gotoPayments() {
      this.$router.push({ name: "payment" });
    },
    onSelectDeliveries(opt) {
      //   console.log(this.details.subscription_days);
      //   var dy = this.daysDetails.filter(item => item.id == opt);
      //   var calc_date = new Date(Date.now() + dy[0].duration * 86400000);
      //   console.log(moment(calc_date).format("dddd"));
      //   var weekday = "";
      //   if (moment(calc_date).format("dddd") == "Monday") {
      //     weekday = 1;
      //   } else if (moment(calc_date).format("dddd") == "Tuesday") {
      //     weekday = 2;
      //   } else if (moment(calc_date).format("dddd") == "Wednesday") {
      //     weekday = 3;
      //   } else if (moment(calc_date).format("dddd") == "Thursday") {
      //     weekday = 4;
      //   } else if (moment(calc_date).format("dddd") == "Friday") {
      //     weekday = 5;
      //   } else if (moment(calc_date).format("dddd") == "Saturday") {
      //     weekday = 6;
      //   } else {
      //     weekday = 7;
      //   }
      //   for (var i = 0; i < this.details.subscription_days.length; i++) {}
    },
    setDate(date) {
      if (date) {
        this.getDeliverySchedule(moment(date).format("YYYY-MM-DD"));
      }
    },
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity === 0) {
        // alert("Negative quantity not allowed");
      } else {
        this.quantity--;
      }
    },
    getDuration() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          vendor_id: localStorage.getItem("vendorId"),
          token: localStorage.getItem("token")
        };
        getDeliveryDuration(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              this.daysDetails = result.data.data;

              for (var i = 0; i < this.daysDetails.length; i++) {
                var dayName = "";
                if (this.daysDetails[i].name == "Day") {
                  dayName = "Delivery";
                } else {
                  dayName = "Deliveries";
                }
                this.getDays.push({
                  text: this.daysDetails[i].duration + " " + dayName,
                  value: this.daysDetails[i].id
                });
              }
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    },
    getDeliverySchedule(selectDate) {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          vendor_id: localStorage.getItem("vendorId"),
          token: localStorage.getItem("token"),
          category_id: this.details.category_id,
          address_id: this.details.user_address_id,
          product_id: this.details.productId,
          selected_date: selectDate
        };
        getDeliveries(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              var schedule = result.data.provideDeliveryTimingCustomer;
              // console.log("schedule", schedule);
              for (var i = 0; i < schedule.length; i++) {
                this.deliverySchedules.push({
                  text:
                    schedule[i].name +
                    " (" +
                    schedule[i].start_time +
                    " to " +
                    schedule[i].end_time +
                    ")",
                  value: schedule[i].d_s_id
                });
              }
              // console.log(">>>>>>>>", this.deliverySchedules);
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    }
  }
};
</script>
